import { render, staticRenderFns } from "./PersonEdit.vue?vue&type=template&id=c68a9b50&scoped=true&"
import script from "./PersonEdit.vue?vue&type=script&lang=js&"
export * from "./PersonEdit.vue?vue&type=script&lang=js&"
import style0 from "./PersonEdit.vue?vue&type=style&index=0&id=c68a9b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68a9b50",
  null
  
)

export default component.exports